<template>
  <v-layout class="scroll-y" :class="$store.getters.isFirstAccess ? 'gradient-oblique first-access--view' : ''">

    <v-flex v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate size="60" width="5"/>
    </v-flex>

    <v-flex v-else>

      <v-card v-if="!$store.getters.isFirstAccess">

        <v-card-title class="title">{{ $t('impostazioni.label.gestione_account') }}</v-card-title>

        <v-card-text>
          <v-btn color="accent" @click="passwordDialogShow = true">{{ $t('impostazioni.azioni.modifica_password') }}</v-btn>
          <v-btn color="accent" flat @click="onboardingDialogShow = true">{{ $t('impostazioni.azioni.apri_guida') }}</v-btn>
        </v-card-text>

      </v-card>

      <v-card class="mt-2">
        <v-form v-model="valid" ref="form" id="settings-form" lazy-validation @submit.prevent="validateForm">

          <v-card-title>
            <span v-if="!$store.getters.isFirstAccess" class="title">{{ $t('impostazioni.label.dati_azienda') }}</span>
            <div v-else class="display-1 d-flex align-center justify-center">
              <v-img src="./img/logo.svg" contain height="56px" width="56px" class="ml-3"/>
              <span class="ml-3">{{ $t('impostazioni.messaggi.compilazione_primo_accesso') }}</span>
            </div>
          </v-card-title>

          <v-card-text>
            <v-container fluid grid-list-lg class="pb-0">
              <v-layout wrap>

                <v-flex xs12>
                  <icon-label icon="business" color="accent">{{ $t('impostazioni.label.dati_azienda') }}</icon-label>
                </v-flex>
                
                <!-- PTR
                <v-flex xs12 class="body-2 mt-1">
                  <span class="mr-2">{{ $t('impostazioni.label.scadenza_iscrizione') }}: </span>
                  <b>{{ $d($utils.date.toJs(form.data_scadenza)) }}</b>
                </v-flex>
                -->

                <v-flex xs12 class="body-2 mt-1">
                  <span class="mr-2">{{ $t('label.partita_iva') }}:</span>
                  <b>{{ form.partita_iva }}</b>
                </v-flex>

                <v-flex xs12 sm2>
                  <text-field :label="$t('impostazioni.label.numero_centro')" v-model="form.numero_centro" required maxlength="10"/>
                </v-flex>

                <v-flex xs12 sm4 md3>
                  <!-- <text-field :label="$t('label.data_nascita')" v-model="form.data_nascita" required/> -->

                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.data_centro"
                        :label="$t('impostazioni.label.data_centro')"
                        hint="YYYY-MM-DD"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="date = formatDate(form.data_centro)"
                        v-on="on"
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      @input="menu1 = false"
                      :locale="$i18n.locale"
                      first-day-of-week="1"
                      v-model="form.data_centro"
                      event-color="accent"
                      color="primary"
                      header-color="white"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm4>
                  <text-field :label="$t('label.ragione_sociale')" v-model="form.ragione_sociale" required/>
                </v-flex>

                <!-- PTR immagini: logo, firma e timbro -->
                <v-flex xs12>
                  <image-input
                    :label="$t('impostazioni.label.banner')"
                    v-model="logo"
                    :preview="$api.azienda.getLogoUrl()"
                    :hint="$t('impostazioni.label.banner_info')"
                    :aspect-ratio="6/1"/>
                </v-flex>
                
                <!--
                <v-flex xs12>
                  <image-input
                    :label="$t('impostazioni.label.firma_titolare')"
                    v-model="firma_titolare"
                    :preview="$api.azienda.getFirmaTitolareUrl()"
                    :hint="$t('impostazioni.label.banner_info_titolare')"/>
                </v-flex>

                
                <v-flex xs12>
                  <image-input
                    :label="$t('impostazioni.label.timbro')"
                    v-model="timbro"
                    :preview="$api.azienda.getTimbroUrl()"
                    :hint="$t('impostazioni.label.banner_info_timbro')"/>
                </v-flex>
                -->
                
                <v-flex xs12 class="mt-4">
                  <icon-label icon="location_on" color="accent">{{ $t('label.indirizzoLegale') }}</icon-label>
                </v-flex>

                <v-flex xs12>
                  <indirizzo-select
                    :paese.sync="form.nazione"
                    :regione.sync="form.regione"
                    :provincia.sync="form.provincia"
                    :comune.sync="form.comune"
                    :cap.sync="form.cap"
                    :via.sync="form.via"
                    :numero-civico.sync="form.numero_civico"
                    :telefono.sync="form.telefono"
                    :paeseDisabled="!$store.getters.isFirstAccess"
                    required
                    attach/>
                </v-flex>
                
                <!-- PTR
                <v-flex xs12 class="mt-4">
                  <icon-label icon="location_on" color="accent">{{ $t('label.indirizzoOperativo') }}</icon-label>
                </v-flex>

                <v-flex xs12>
                  <indirizzo-select
                    :paese.sync="form.nazione"
                    :regione.sync="form.regione"
                    :provincia.sync="form.provincia_operativa"
                    :comune.sync="form.comune_operativa"
                    :cap.sync="form.cap"
                    :via.sync="form.via_operativa"
                    :numero-civico.sync="form.numero_civico_operativa"
                    :telefono.sync="form.telefono_operativa"
                    :paeseDisabled="!$store.getters.isFirstAccess"
                    required
                    attach/>
                </v-flex>
                -->

                <v-flex xs12 class="mt-4">
                  <icon-label icon="contacts" color="accent">{{ $t('label.contatti') }}</icon-label>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <text-field
                    :label="$t('label.email')"
                    v-model="form.email"
                    required
                    show-details
                    :v-rules="[$utils.rules.email]"/>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <phone-field :label="$t('label.telefono')" v-model="form.telefono" show-details/>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <mobile-phone-field :label="$t('label.cellulare')" v-model="form.cellulare" show-details/>
                </v-flex>

                <v-flex xs12>
                  <text-field
                    :label="$t('label.sito_web')"
                    hint="http://..."
                    show-details
                    v-model="form.sito_web"/>
                </v-flex>

                <v-flex xs12 class="mt-4">
                  <icon-label icon="person" color="accent">{{ $t('label.titolare') }}</icon-label>
                </v-flex>

                <v-flex xs12 sm4 md3>
                  <text-field :label="$t('label.nome_titolare')" v-model="form.nome_titolare" required/>
                </v-flex>

                <v-flex xs12 sm4 md3>
                  <!-- <text-field :label="$t('label.data_nascita')" v-model="form.data_nascita" required/> -->

                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.data_nascita"
                        :label="$t('label.data_nascita')"
                        hint="YYYY-MM-DD"
                        persistent-hint
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        @blur="date = formatDate(form.data_nascita)"
                        v-on="on"
                        :rules="[v => !!v || '']"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      no-title
                      @input="menu2 = false"
                      :locale="$i18n.locale"
                      first-day-of-week="1"
                      v-model="form.data_nascita"
                      event-color="accent"
                      color="primary"
                      header-color="white"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <!--
                <v-flex xs12 class="mt-2">
                  <indirizzo-select-not-req
                    :paese.sync="form.nazione"
                    :regione.sync="form.regione"
                    :provincia_nascita.sync="form.provincia_nascita"
                    :comune_nascita.sync="form.comune_nascita"
                    :provincia_titolare.sync="form.provincia_titolare"
                    :comune_titolare.sync="form.comune_titolare"
                    :cap.sync="form.cap_titolare"
                    :via.sync="form.via_titolare"
                    :numero-civico.sync="form.numero_civico_titolare"
                    :telefono.sync="form.telefono_titolare"
                    :paeseDisabled="!$store.getters.isFirstAccess"
                    required
                    attach/>
                </v-flex>
                -->
              </v-layout>
            </v-container>

          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="accent" type="submit" form="settings-form" :disabled="!valid" :loading="sending">
              {{ $t('azioni.conferma') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>

    </v-flex>

    <password-dialog v-model="passwordDialogShow"/>
    <onboarding-dialog v-model="onboardingDialogShow"/>

  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import PasswordDialog from '@/components/PasswordDialog'
import { IndirizzoSelect, IndirizzoSelectNotReq, PhoneField, MobilePhoneField, ImageInput } from '@/components/inputs'
import OnboardingDialog from '@/components/OnboardingDialog'
// import moment from 'moment'

export default {
    name: 'Settings',
    components: { OnboardingDialog, IndirizzoSelect, IndirizzoSelectNotReq, PasswordDialog, PhoneField, MobilePhoneField, ImageInput },
    data: vm => ({
        form: {},
        logo: null,
        firma_titolare: null,
        timbro: null,
        passwordDialogShow: false,
        onboardingDialogShow: false,
        valid: true,
        sending: false,
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        dateFormatted: vm.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
        menu1: false,
        menu2: false
    }),
    created () {
        this.form = Object.assign({}, this.azienda)
        this.fetchAzienda(false)
    },
    watch: {
        azienda: {
            handler (val) {
                this.form = Object.assign({}, val)
                if (this.form.data_nascita === '0001-01-01') {
                    this.form.data_nascita = ''
                }
                if (this.form.data_centro === '0001-01-01') {
                    this.form.data_centro = ''
                }
            },
            deep: true
        },
        date (val) {
            this.dateFormatted = this.formatDate(this.date)
        }
    },
    computed: {
        ...mapState({
            azienda: state => state.global.azienda,
            loading: state => state.global.loading.azienda
        }),
        computedDateFormatted () {
            return this.formatDate(this.date)
        }
    },
    methods: {
        getComputedForm () {
            let computedForm = new FormData()
            for (let key in this.form) {
                if (key !== 'logo' && key !== 'firma_titolare' && key !== 'timbro') {
                    computedForm.append(key, this.form[key])
                }
            }
            //computedForm.append('nome_azienda', this.form.ragione_sociale)
            /* PTR
            if (this.logo !== null) {
                computedForm.append('logo', this.logo)
            }
            if (this.firma_titolare !== null) {
                computedForm.append('firma_titolare', this.firma_titolare)
            }
            if (this.timbro !== null) {
                computedForm.append('timbro', this.timbro)
            }
            */
            return computedForm
        },
        validateForm () {
            if (this.$refs.form.validate()) {
                this.send()
            }
        },
        send () {
            this.sending = true
            this.$api.azienda.update(this.getComputedForm())
                .then(response => {
                    this.sending = false
                    this.$snackbar.show(this.$t('impostazioni.messaggi.modificato'), 'success')
                    this.fetchAzienda(true) // Forzo il download dei dati modificati dell'azienda
                    if (this.$store.getters.isFirstAccess) {
                        this.$store.commit('SET_IS_FIRST_ACCESS', false)
                        this.$router.push('/avvisi')
                    }
                })
                .catch(e => {
                    this.sending = false
                    this.$snackbar.showServerError(e)
                })
        },
        fetchAzienda (forceUpdate = false) {
            this.$store.dispatch('loadAzienda', forceUpdate).catch(e => {
                this.$snackbar.showServerError(e)
            })
        },
        // formatDate (value) {
        //     if (value) {
        //         return moment(String(value)).format('YYYY-MM-DD')
        //     }
        // },
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        }
    }
}

</script>
<style lang="scss" scoped>
  .first-access--view {
    padding: 60px 100px;
    height: 100vh;
  }
</style>
